export default __webpack_public_path__ + "static/media/ryanair.47a86691.png";